import type { ApiEndpoint } from '../endpointsConfig'

export const publicMenuEndpoints: ApiEndpoint[] = [
  {
    name: 'menuConfig',
    path: 'restohub-api/menu-builder/public/config/',
    actions: ['GET'],
    tags: ['MenuConfig'],
  },
  {
    name: 'waitTime',
    path: 'restohub-api/menu-builder/public/wait-time/{restaurant_id}/',
    actions: ['GET'],
    tags: ['WaitTime'],
  },
]
